import ky from 'ky'
import ReconnectingWebSocket from 'reconnecting-websocket'

/**
 * A rough client for dashund ~ https://www.npmjs.com/package/dashund
 * - #subscribe to dashund endpoints to fetch and recieve updates
 * - #unsubscribe to stop receiving updated data
 */
export class DashundClient {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
    this.agent = ky.extend({ prefixUrl: baseUrl })
    this.socket = new ReconnectingWebSocket(baseUrl.replace(/^http/, 'ws'))
    this.subscriptions = new Map()

    // When a message is received, call any registered handlers
    this.socket.onmessage = e => {
      const { type = '', ...payload } = JSON.parse(e.data)
      const subs = this.subscriptions.get(type) || []

      for (const handler of subs) handler(payload)
    }

    // Send dashund subscriptions when the socket is (re)opened
    this.socket.onopen = e => {
      for (const eventName of this.subscriptions.keys()) {
        this.emitEvent('sub', { target: eventName })
      }
    }
  }

  /** protected - emit an event to the dashund server */
  emitEvent(type, payload) {
    this.socket.send(JSON.stringify({ type, ...payload }))
  }

  /** Subscribe to an endpoint, fetching an initial value and socket subscribe  */
  async subscribe(eventName, handler) {
    const result = await this.agent.get(eventName).json()
    handler(result)

    // Only emit an event when the connection is open
    // socket.onopen will register them otherwise
    if (this.socket.readyState === WebSocket.OPEN) {
      this.emitEvent('sub', { target: eventName })
    }

    this.subscriptions.set(
      eventName,
      (this.subscriptions.get(eventName) || []).concat([handler])
    )
  }

  /** Unsubscribe a callback from receiving updated data */
  unsubscribe(eventName, handler) {
    if (!this.subscriptions.has(eventName)) return

    // Remove the handler
    const newSubs = this.subscriptions.get(eventName).filter(h => h !== handler)
    this.subscriptions.set(newSubs)

    // If there are no subs left unsubscribe from the socket
    if (newSubs.length === 0) this.emitEvent('unsub', { target: eventName })
  }

  /** Close the socket connection */
  close() {
    this.socket.close()
  }
}
